// src/utils/axiosConfig.js
import axios from "axios";
import Utils from "./Utils";
import Swal from "sweetalert2";

// Response interceptor: Runs on every successful response
axios.interceptors.response.use(
  (response) => {
    // Common code here (e.g., log response data)
    if (!response.data.success) {
      if (response.data.resetpwd) {
        Swal.fire({
          icon: "error",
          title: "Password Expired",
          text: response.data.message || "Session expired. Please login again.",
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: "Reset Password",
        }).then((result) => {
          if (result.isConfirmed) {
            console.log("Navigating to:", response.data.navigateTo);
            window.location.href = response.data.navigateTo || "/"; // Redirect to reset password page or home
          }
        });
      } else if (response.data.tokenExpired) {
        Swal.fire({
          icon: "error",
          title: "Token Expired",
          text: response.data.message || "Session expired. Please login again.",
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: "Login Now",
        }).then((result) => {
          if (result.isConfirmed) {
            Utils.removeSession();
            window.location.href = "/";
          }
        });
      }
    }

    // You can add more logic, like checking for specific status codes
    // if (response.status === 200) { /* do something */ }

    return response; // Always return the response to continue the chain
  },
  (error) => {
    // Common error handling (e.g., log errors or show notifications)
    console.error(
      "Axios Error:",
      error.response ? error.response.data : error.message,
    );

    // You can add global error handling, like redirecting on 401
    // if (error.response && error.response.status === 401) { /* redirect to login */ }

    return Promise.reject(error); // Reject to propagate the error
  },
);

export default axios;
